(function(module) {
    module.factory('Offer', ['$mdDialog', '$http', 'EmarketConstant', function($mdDialog, $http, EmarketConstant) {

        var offer = {
            showManageDialog: function(post) {
                var offerDialog = $mdDialog.show({
                    templateUrl: 'main/post/offer/offer-manage.tpl.html',
                    controller: 'offerManageDialog as model',
                    locals: {
                      post: post
                    }
                });
                return offerDialog;
            },
            accept: function(post, offer) {

            },
            reject: function(post, offer) {

            },
            showDialog: function(post, offers) {
                var id = post ? post._id || post : null;
                //TODO get the post offer
                var dialog = $mdDialog.show({
                    templateUrl: 'main/post/offer/offer-list.tpl.html',
                    controller: 'offer as model',
                    locals: {
                        offers: offers,
                        postId: id
                    }
                });
                return dialog;
            },
            make: function(postId, amount) {
                return $http.post(EmarketConstant.path + '/api/post/' + postId + '/offer', {
                    amount: amount
                }).then(function(response) {
                    console.log(response);
                });
            }
        };
        return offer;
    }]);
}(angular.module('emarket.main.post')));
